module.exports = __webpack_public_path__ + "img/sample_subtitle.eb85f4d7.png";